module.exports = __webpack_public_path__ + "img/user-pen.481d5017.svg";